module.exports = __webpack_public_path__ + "static/img/website--AR--About-us.6487711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/website--AR--About-us.jpg
// module id = 1338
// module chunks = 4